<div class="flex flex-column align-items-center gap-5">
    <h3 class="title">Iniciar sesión</h3>
    <p-messages key="user" [closable]="false" class="w-10"></p-messages>
    <div class="flex justify-content-evenly">
        <form [formGroup]="loginForm" (ngSubmit)="login()">
            <div class="field mb-5">
                <span class="p-input-icon-right p-float-label w-full">
                    <input type="text" id="username" pInputText class="p-inputtext-lg w-full" formControlName="username"
                        maxlength="10" minlength="10" autofocus="true"
                        [class.ng-invalid]="this.loginForm.get('username')?.invalid && this.loginForm.get('username')?.touched" />
                    <label htmlFor="username">Número celular</label>
                </span>
            </div>
            <div class="field mb-5">
                <span class="p-float-label">
                    <p-password id="password" formControlName="password" [feedback]="false"
                        maxlength="20" minlength="6" class="w-full" inputStyleClass="w-full p-inputtext-lg" styleClass="w-full"
                        [class.ng-invalid]="this.loginForm.get('password')?.invalid && this.loginForm.get('password')?.touched"></p-password>
                        <label htmlFor="password">Contraseña</label>
                    </span>
            </div>
            <div class="flex justify-content-center">
                <p-button label="Entrar" type="submit" [disabled]="loginForm.invalid || loginForm.pending"></p-button>
            </div>
        </form>
    </div>
    <p>¿Aún no tienes cuenta? <a class="link" label="Registrarse" [routerLink]="['/crear-perfil-escort']">Registrarse</a></p>
</div>